import { appConfig } from '../../../appConfig';
import { Helpers } from '../../../utility/helpers';

export const BLOOMREACH_MARKETING_CAMPAIGN = 'utm_campaign';
export const BLOOMREACH_MARKETING_CAMPAIGN_ID = 'utm_campaign_id';
export const BLOOMREACH_MARKETING_MEDIUM = 'utm_medium';
export const BLOOMREACH_MARKETING_SOURCE = 'utm_source';

const BLOOMREACHID_HEADER = 'beId';
const SESSION_STORAGE_BE_IDENTITY = 'user.identity.be';

/**
 * This will return beId if it exists as a query parameter.
 * If user is not authenticated, it will store beId to session storage.
 * If user doesn't have it in query parameter and is still not authenticated it will return beId from session storage.
 */
export const getBloomreachId = () => {
    const beId = Helpers.getParameterByName(BLOOMREACHID_HEADER);

    if (!appConfig.coopUserSettings.isAuthenticated) {
        if (beId) {
            window.sessionStorage.setItem(SESSION_STORAGE_BE_IDENTITY, beId);
        } else {
            const storedBeId = window.sessionStorage.getItem(SESSION_STORAGE_BE_IDENTITY);
            return storedBeId ?? undefined;
        }
    }

    return beId;
};
